"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortingOrder = exports.OriginalMode = exports.ButtonMode = exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["VISIBLE"] = "VISIBLE";
    EventType["DOM"] = "DOM_CHANGE";
})(EventType || (exports.EventType = EventType = {}));
var ButtonMode;
(function (ButtonMode) {
    ButtonMode["REPLACE"] = "REPLACE";
    ButtonMode["UPDATE"] = "UPDATE";
    ButtonMode["ALTERNATIVE"] = "ALTERNATIVE";
    ButtonMode["DEFAULT"] = "DEFAULT";
})(ButtonMode || (exports.ButtonMode = ButtonMode = {}));
var OriginalMode;
(function (OriginalMode) {
    OriginalMode[OriginalMode["NO_ACTION"] = 0] = "NO_ACTION";
    OriginalMode[OriginalMode["UPDATE"] = 1] = "UPDATE";
    OriginalMode[OriginalMode["REPLACE"] = 2] = "REPLACE";
})(OriginalMode || (exports.OriginalMode = OriginalMode = {}));
var SortingOrder;
(function (SortingOrder) {
    SortingOrder["ASC"] = "ascending";
    SortingOrder["DESC"] = "descending";
})(SortingOrder || (exports.SortingOrder = SortingOrder = {}));
